<div class="screen-container d-flex fd-col jc-start ai-stretch">
  <div class="d-flex fd-row flex-wrap jc-start ai-stretch">
    <h4 class="margin">Organisation Profile</h4>
  </div>
  <div class="d-flex fd-row flex-wrap jc-start ai-stretch">
    <div class="margin card flex-1 d-flex fd-col ai-stretch">
      <div class="padding">
        <suvo-users-card-entry label="Organisation Name" [entryControl]="selectedOrganisationName" (entrySaved)="updateOrganisation()" [forbidEdit]="selectedOrganisation?.value?.role !== 'ADMIN'">
        </suvo-users-card-entry>
      </div>
    </div>
  </div>
</div>